// @ts-ignore
import removeMd from 'remove-markdown';

export const clearMarkdown = (markdownText: string): string => {
  return removeMd(markdownText, { useImgAltText: false });
};
